import {
  sysUserMenu_add,
  sysUserMenu_query_setting,
  sysEntityExtControl_listByType,
  sysDocExtControl_listByType,
  sysNumber_queryNumberLength,
  sysDocCirculationConfig_listButtonCanShow,
  sysButtonConfig_listButtonCanShow,
  sysDocCache_saveNewOrUpdate,
  sysDocCache_getSysDocCacheVoByKey,
  sysGlobalNumber_canUseIndexDocNumber,
  getCharacteristicSwitchByKey
} from '@/api/myController/system.js';
import { listAll } from '@/api/myController/SysGlobalDictController';
import { setObjectToSessionStorage, getObjectFromSessionStorage, formatDate } from '@/utils'
import { SysGlobalDictController, SystemController, SysCommonBizController } from '@/api';

import _this from '@/main.js'

// 日期转换
export function convertDate(time) {
  if (time) {
    try {
      time = _this.$moment(time).format("YYYY-MM-DD"); // 获取当前时间
    } catch (error) { }
    return time;
  } else {
    return time;
  }
}

// 根据用户ID查询用户详情信息
export async function userDetailsData(userId) {
  let data = {}
  await SystemController.getUser(this, { userId: userId })
    .then((res) => {
      data = res.data
    })
    .catch((e) => {
    });
  return data
}

// 特性开关根据key查询
export async function characteristicWwitch(key) {
  let data = null
  await getCharacteristicSwitchByKey({
    key: key
  }).then(res => {
    try {
      data = res.data.data.characteristicSwitchIsUse
    } catch (error) {

    }
  })
  return data
}

// 判断编号是否重复
export async function judgeNumber(docNumber, globalNumberId) {
  if (!globalNumberId) {
    globalNumberId = 0
  }
  let json = {
    docNumber,
    globalNumberId
  }
  let state = true
  if (docNumber) {
    await sysGlobalNumber_canUseIndexDocNumber(json).then(res => {
      state = res.data.data
    })
  }
  if (state === false) {
    this.$message.warning('编号重复！禁止操作！');
    throw new Error('编号重复！');
  }
}

// 防止连续点击
export function requestRepeat(time = 1000, key = 'all') {
  if (!_this.repeatDataTimeData[key] || (new Date().getTime() - _this.repeatDataTimeData[key] > time)) {
    _this.repeatDataTimeData[key] = new Date().getTime();
  } else {
    _this.repeatDataTimeData[key] = new Date().getTime();
    this.$message.warning('请求频率过快！');
    throw new Error('请求频率过快！');
  }
}

/**
 * 自定义字段格式化
 * @param {Array} list 需要格式化的数据
 * @param {Boolean} alwaysEditState 是否一直为编辑状态
 * @param {Boolean} canEdit 是否可编辑
 * @param {Number} width 宽度
 * @param {Boolean} fixedState 是否固定
 * @param {Boolean} isShow 是否显示
 * @param {Boolean} sortable 是否可排序
 * @returns
 */
export function getSysEntityExt(list = [], alwaysEditState = false, canEdit = true, width = 120, fixedState = false, isShow = true, sortable = false) {
  // console.log("-------------------list", list)
  // console.log("-------------------alwaysEditState", alwaysEditState)
  // console.log("-------------------canEdit", canEdit)
  // console.log("-------------------width", width)
  // console.log("-------------------fixedState", fixedState)
  // console.log("-------------------isShow", isShow)
  // console.log("-------------------sortable", sortable)
  let extList = [];
  list.forEach((item) => {
    let selectOptionList = [];
    let dataType = 'text';
    switch (item.fieldType) {
      case 0:
        dataType = 'text';
        break;
      case 1:
        dataType = 'customSelect';
        selectOptionList = JSON.parse(item.fieldTypeRelinfo);
        break;
      case 2:
        dataType = 'excel';
        selectOptionList = JSON.parse(item.fieldTypeRelinfo || '{}');
        break;
      case 3:
        dataType = 'dateTime';
        break;
      case 4:
        dataType = 'dateTimeV2';
        break;
      case 5:
        dataType = 'fileList';
        break;
      default:
        dataType = 'text';
        break;
    }
    let json = {
      id: item.extControlId,
      name: item.fieldName,
      value: item.fieldTag,
      fixedState: fixedState,
      isShow: isShow,
      dataType: dataType,
      selectOptionKey: '',
      selectOptionList: selectOptionList,
      alwaysEditState: alwaysEditState,
      canEdit: canEdit,
      width: width,
      sortable: sortable
    };
    extList.push(json);
  });
  return extList;
}

// 重置菜单栏样式不变
export function customStyleMenu(listOne, listTwo) {
  // 原始 listOne
  // 新 listTwo
  try {
    listTwo.forEach(item => {
      if (!item.sort) {
        item.sort = null;
      }
      if (!item.align) {
        item.align = null;
      }
      let single = listOne.filter(a => a.value === item.value)
      if (single.length > 0) {
        item.width = single[0].width
        item.align = single[0].align
        item.sort = single[0].sort
        item.fixedState = single[0].fixedState
        item.isShow = single[0].isShow
        item.userList = single[0].userList
      }
    })
  } catch (error) {
  }
  return listTwo
}

// 自动合并处理菜单栏
export function customMenu(listOne, listTwo, listThree) {
  try {
    // 数据库中拉取的list
    // listOne = [{ id: 1, name: "测试1", width: 100 }, { id: 1, name: "测试2", width: 100 }, { id: 1, name: "测试3", width: 100 }]
    // // 页面默认list
    // listTwo = [{ id: 1, name: "测试1", width: 50 }, { id: 1, name: "测试2", width: 50 }]
    // // 自定义字段list
    // listThree = [{ id: 1, name: "测试3", width: 50 }, { id: 1, name: "测试4", width: 50 }]
    // 合并list
    let listFour = [...listTwo, ...listThree]
    // 以数据库中拉取数据为主，调整数据
    let returnList = []
    listOne.forEach(item => {
      listFour.forEach(element => {
        if (item.value == element.value) {
          returnList.push(item)
        }
      })
    });
    listFour.forEach(item => {
      let single = listOne.filter((element) => {
        return element.value == item.value;
      });
      if (single.length == 0) {
        returnList.push(item)
      }
    })
    // 最后集合去重，如有重复保留第一个对象
    try {
      const res = new Map()
      returnList = returnList.filter((item) => !res.has(item.value) && res.set(item.value, 1))
    } catch (error) {
    }
    return returnList
  } catch (error) {
    return listOne
  }
}

// 新增页面缓存
export async function sysDocCacheSaveNewOrUpdate(key, data) {
  let json = {
    docCacheKey: key,
    docCacheValue: data
  }
  sysDocCache_saveNewOrUpdate(json).then(res => {

  })
}

// 查询缓存
export async function sysDocCacheGetSysDocCacheVoByKey(key) {
  let json = {
    key: key
  }
  let data = null
  await sysDocCache_getSysDocCacheVoByKey(json).then(res => {
    data = res.data.data.docCacheValue
  })
  return data
}

// 获取页面按钮（老接口）
export async function getSysButtonaList(docTypeId, sysDocCirculationConfigModelId, list = [], noList = []) {
  // docTypeId 判断审核按钮
  // sysDocCirculationConfigModelId 页面ID
  let json = {
    docTypeId: docTypeId,
    sysDocCirculationConfigDto: {
      sysDocCirculationButtonIsUse: 1,
      sysDocCirculationConfigModelId: sysDocCirculationConfigModelId
    }
  };
  let tableBtnList = []
  await sysDocCirculationConfig_listButtonCanShow(json).then((res) => {
    let tableList = [];
    res.data.data.dataList.forEach((item) => {
      if (
        noList.filter((a) => a === item.sysDocCirculationConfigButtonName)
          .length === 0
      ) {
        tableList.push(item.sysDocCirculationConfigButtonName);
      }
    });
    tableBtnList = [...tableList, ...list];
  });
  return tableBtnList
}

// 获取页面按钮（新接口）
export async function getNewSysButtonaList(docTypeId, sysButtonConfigModelId, sysButtonConfigButtonRote, list = [], noList = []) {
  let json = {
    docTypeId: docTypeId,
    sysButtonConfigDto: {
      sysButtonIsUse: 1,
      sysButtonConfigButtonRote: sysButtonConfigButtonRote,
      sysButtonConfigModelId: sysButtonConfigModelId
    }
  };
  let tableBtnList = []
  await sysButtonConfig_listButtonCanShow(json).then((res) => {
    let tableList = [];
    res.data.data.dataList.forEach((item) => {
      if (
        noList.filter((a) => a === item.sysButtonConfigButtonName)
          .length === 0
      ) {
        tableList.push(item.sysButtonConfigButtonName);
      }
    });
    tableBtnList = [...tableList, ...list];
  });
  return tableBtnList
}

// 剩余时间，天
// 计算两个时间的差值
export function timeInterval(time) {
  if (!time) {
    return '暂无时间';
  }
  try {
    let stime = Date.parse(new Date(time));
    let etime = Date.parse(new Date(year() + '-' + month() + '-' + day()));
    if (stime < etime) {
      return '已超期';
    }
    // 两个时间戳相差的毫秒数
    let usedTime = stime - etime;
    // 计算相差的天数
    let days = Math.floor(usedTime / (24 * 3600000)) + 1;
    // 计算天数后剩余的毫秒数
    let leave1 = usedTime % (24 * 3600000);
    // 计算出小时数
    let hours = days * 24 + Math.floor(leave1 / 3600000);
    // 计算小时数后剩余的毫秒数
    let leave2 = leave1 % 3600000;
    // 计算相差分钟数
    var minutes = Math.floor(leave2 / 60000);
    return days;
  } catch (error) {
    return '暂无时间';
  }
}

// 排序
export function sortList(list, value) {
  // list.sort((a, b) => a[value] - b[value]);
  list.sort((a, b) => {
    if (!a[value] && b[value]) {
      return 1;
      // 把空值放在最后
    } else if (a[value] && !b[value]) {
      return -1;
      // 把空值放在最后
    } else {
      return a[value] - b[value];
      // 其他情况按照数字大小排序
    }
  });
}

// 全局搜索码
export async function QJSSM(number = 4) {
  var data = ''
  let jsons = {
    length: number,
    orderType: 'QJSSM'
  };
  await sysNumber_queryNumberLength(jsons).then((res) => {
    data = res.data.data;
  });
  return data
}

// 产品自定义字段
export function setSysEntityExt_1(that) {
  sysEntityExtControl_listByType({
    sysEntityExtControlDto: { extType: 1, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_1 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 客户自定义字段
export function setSysEntityExt_6(that) {
  sysEntityExtControl_listByType({
    sysEntityExtControlDto: { extType: 6, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_6 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 客户跟进记录自定义字段
export function setSysEntityExt_601(that) {
  sysEntityExtControl_listByType({
    sysEntityExtControlDto: { extType: 601, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_601 = res.data.data.dataList
    } catch (error) {
    }
  });
}

// 工序自定义字段
export function setSysEntityExt_8(that) {
  sysEntityExtControl_listByType({
    sysEntityExtControlDto: { extType: 8, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_8 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 供应商自定义字段
export function setSysEntityExt_11(that) {
  sysEntityExtControl_listByType({
    sysEntityExtControlDto: { extType: 11, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_11 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 生产单自定义字段
export function setSysEntityExt_131(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 131, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_131 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 设计中台自定义字段
export function setSysEntityExt_132(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 132, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_132 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 设计中台自定义字段
export function setSysEntityExt_133(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 133, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_133 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// BOM主表自定义字段
export function setSysEntityExt_136(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 136, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_136 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// BOM物料自定义字段
export function setSysEntityExt_137(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 137, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_137 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// BOM工序自定义字段
export function setSysEntityExt_138(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 138, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_138 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 样品单主表
export function setSysEntityExt_151(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 151, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_151 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 样品单子表
export function setSysEntityExt_152(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 152, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_152 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 日报表
export function setSysEntityExt_153(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 153, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_153 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 会议表
export function setSysEntityExt_170(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 170, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_170 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 项目管理
export function setSysEntityExt_183(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 183, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_183 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 收支明细
export function setSysEntityExt_185(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 185, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_185 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 销售订单主表自定义字段
export function setSysEntityExt_101(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 101, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_101 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 销售订单子表自定义字段
export function setSysEntityExt_102(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 102, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_102 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 销售出库订单子表自定义字段
export function setSysEntityExt_103(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 103, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_103 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 销售出库订单子表自定义字段
export function setSysEntityExt_104(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 104, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_104 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 销售对账订单自定义字段
export function setSysEntityExt_105(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 105, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_105 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 采购订单主表自定义字段
export function setSysEntityExt_121(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 121, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_121 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 采购订单子表自定义字段
export function setSysEntityExt_122(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 122, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_122 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 采购出库订单主表自定义字段
export function setSysEntityExt_123(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 123, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_123 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 采购出库订单子表自定义字段
export function setSysEntityExt_124(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 124, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_124 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 采购对账订单自定义字段
export function setSysEntityExt_125(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 125, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_125 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 报价订单自定义字段
export function setSysEntityExt_141(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 141, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_141 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 报价订单明细自定义字段
export function setSysEntityExt_142(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 142, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_142 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 质检自定义字段
export function setSysEntityExt_134(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 134, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_134 = res.data.data.dataList
    } catch (error) {

    }
  });
}

// 委外自定义字段
export function setSysEntityExt_139(that) {
  sysDocExtControl_listByType({
    sysDocExtControlDto: { extType: 139, fieldIsUsed: 1 }
  }).then((res) => {
    try {
      that.$root.sysEntityExt_139 = res.data.data.dataList
    } catch (error) {

    }
  });
}


// 收款模式
export function getPricePaymentMode(that) {
  getSettingByKeyAll({
    key: 'PAYMENT_MODE'
  }).then((res) => {
    try {
      that.$root.paymentMode = res.data.data.settingValue;
    } catch (error) {

    }
  });
}

// 数量进度
export function getSumAccuracy(that) {
  getSettingByKeyAll({
    key: 'SUM_ACCURACY'
  }).then((res) => {
    try {
      that.$root.numberAccuracy = res.data.data.settingValue;
    } catch (error) {

    }
  });
}


// 修改自定义菜单
export function updateSetting(that, key, value) {
  let sysUserMenuDto = {
    createDeptId: that.getUserInfo.userDeptId,
    userId: that.getUserInfo.userId,
    menuKey: key,
    menuValue: value
  }
  sysUserMenu_add({ sysUserMenuDto: sysUserMenuDto }).then(res => {
  })
}

// 查询自定义菜单
export async function selcetSetting(key) {
  let titleList = null
  await sysUserMenu_query_setting({ menuKey: key }).then(res => {
    if (res.data.data) {
      try {
        titleList = JSON.parse(res.data.data.menuValue)
      } catch (error) {
        titleList = res.data.data.menuValue
      }
    }
  })
  if (titleList == '' || titleList == undefined || titleList == {}) {
    titleList = null
  }
  return titleList
}

// 获取字典下拉框数据
export async function dictionarySelect(sysData) {
  let list = []
  await listAll({
    dictCode: sysData
  }).then((res) => {
    list = res.data.data.fullResultList
  })
  return list
}

// 缓存字典
export function cacheDictionarySelect(that) {
  SysGlobalDictController.list(that, {}).then(res => {
    res.data.dataList.forEach(async item => {
      item.itemList = []
      item.itemList = await dictionarySelect(item.dictCode)
      setObjectToSessionStorage('dictionarySelect', res.data.dataList)
    })
  })
}

// 从缓存字典里读取数据
export function readDictionarySelect(key) {
  let list = []
  try {
    let dictionaryList = getObjectFromSessionStorage('dictionarySelect')
    let dictionarySingle = dictionaryList.filter(item => {
      return item.dictCode == key;
    })
    list = dictionarySingle[0].itemList
    return list
  } catch (error) {
    return list
  }
}

// 缓存员工
export function cacheUserSelect(that) {
  SystemController.getUserList(that, {
  }).then((res) => {
    try {
      setObjectToSessionStorage('userSelect', res.data.dataList)
    } catch (error) {

    }
  });
}

// 根据员工ID查询员工名称
export function readUserSelect(key) {
  let name = ''
  try {
    let userList = getObjectFromSessionStorage('userSelect')
    let user = userList.filter(item => {
      return item.userId == key;
    })
    name = user[0].showName
  } catch (error) {

  }
  return name
}

// 缓存部门信息
export function cacheUserDepSelect(that) {
  let params = {
    widgetType: 'upms_dept',
    filter: {
      deptName: ''
    }
  };
  SysCommonBizController.list(that, params).then((res) => {
    try {
      setObjectToSessionStorage('userDepSelect', res.data.dataList)
    } catch (error) {

    }
  });
}

// 根据部门ID查询部门名称
export function readUserDepSelect(key) {
  let name = ''
  try {
    let list = getObjectFromSessionStorage('userDepSelect')
    let dep = list.filter(item => {
      return item.deptId == key;
    })
    name = dep[0].deptName
  } catch (error) {

  }
  return name
}

// 节流
export function _throttle(fn, wait = 200) {
  let last, timer, now;
  return function () {
    now = Date.now();
    if (last && now - last < wait) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.call(this, ...arguments);
      }, wait);
    } else {
      last = now;
      fn.call(this, ...arguments);
    }
  };
}

// 防抖
export function _debounce(fn, wait = 200) {
  let timer;
  return function () {
    let context = this;
    let args = arguments;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, wait)
  }
}

// 时间戳
export function stamp() {
  return Date.now()
}

// 年
export function year(date = new Date()) {
  return date.getFullYear()
}

// 月
export function month(date = new Date()) {
  return date.getMonth() + 1
}

// 日
export function day(date = new Date()) {
  let day = ''
  if (date.getDate() < 10) {
    day = '0' + date.getDate()
  } else {
    day = date.getDate()
  }
  return day
}

// 时
export function hours() {
  return new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
}

// 分
export function minu() {
  return new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
}

// 秒
export function second() {
  return new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
}

// 获取当前时间
export function getCurrentTime() {
  // 获取当前时间并打印
  let yy = new Date().getFullYear();
  let mm = ('0' + (new Date().getMonth() + 1)).slice(-2);
  let dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
  let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  let gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
  return gettime
}

// 获取当前时间
export function getCurrentDate(date = new Date()) {
  // 获取当前时间并打印
  let yy = date.getFullYear();
  let mm = date.getMonth() + 1 < 10 ? '0' + date.getMonth() + 1 : date.getMonth() + 1;
  let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let gettime = yy + '-' + mm + '-' + dd
  return gettime
}

// 获取当前时间
export function getCurrentTimeData() {
  // 获取当前时间并打印
  const now = new Date();
  const year = String(now.getFullYear()).padStart(4, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 注意月份是从0开始的
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  let gettime = `${year}${month}${day}${hours}${minutes}${seconds}`;
  return gettime
}

/**
 *
 * @param {时间段} date
 * @param {添加天数} days
 * @returns 时间添加天数返回最新时间
 */
export function addDate(date, days) {
  // Clone the original date to avoid modifying it directly
  const newDate = new Date(date);
  // Check if the original date is in December
  if (newDate.getMonth() === 11) {
    // Get the remaining days in December
    const daysInDecember = 31 - newDate.getDate();
    // If the number of days to add is greater than the remaining days in December,
    // set the date to January of the next year and adjust the remaining days to add
    if (days > daysInDecember) {
      newDate.setMonth(0); // January
      newDate.setDate(1); // 1st day of January
      days -= daysInDecember;
    }
  } // Add the remaining days to the date
  newDate.setDate(newDate.getDate() + days);
  let time = formatDate(newDate, 'YYYY-MM-DD HH:mm:ss')
  return time;
}

// 浮数乘
export function mulFloat(arg1, arg2) {
  if (!arg1) {
    arg1 = 0
  }
  if (!arg2) {
    arg2 = 0
  }
  let num = 0
  try {
    var m = 0;
    var s1 = arg1.toString();
    var s2 = arg2.toString();
    try {
      m += s1.split('.')[1].length;
    } catch (e) { }
    try {
      m += s2.split('.')[1].length;
    } catch (e) { }
    num = (Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)) || 0
  } catch (error) {
    num = arg1
  }
  if (num == 'NaN') {
    num = arg1
  }
  try {
    num = num.toFixed(_this.accuracy)
  } catch (error) {

  }
  return num;
}

// 浮数除
export function divFloat(arg1, arg2) {
  if (!arg1) {
    arg1 = 0
  }
  if (!arg2) {
    arg2 = 0
  }
  let num = 0
  try {
    arg1 = parseFloat(arg1);
    arg2 = parseFloat(arg2);
    var t1 = 0;
    var t2 = 0;
    var r1; var r2;
    try {
      t1 = arg1.toString().split('.')[1].length;
    } catch (e) { }
    try {
      t2 = arg2.toString().split('.')[1].length;
    } catch (e) { }
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    num = mulFloat(r1 / r2, Math.pow(10, t2 - t1)) || 0;
    if (num > 9999999999999999999999999999) num = 0;
  } catch (error) {
    num = arg1
  }
  if (num == 'NaN') {
    num = arg1
  }
  try {
    num = num.toFixed(_this.accuracy)
  } catch (error) {

  }
  return num;
}

export function parseNo(typeName = '销售单', part) {
  return new Promise((resolve, reject) => {
    if (part == null) return reject();
    var no = typeName + '-' + part + formatDate(new Date(), 'YYYYMMDDHHmmss')
    resolve(no)
  });
}
// 浮数加
export function accAdd(arg1, arg2) {
  if (!arg1) {
    arg1 = 0
  }
  if (!arg2) {
    arg2 = 0
  }
  let num = 0
  try {
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(100, Math.max(r1, r2));
    // 动态控制精度长度
    n = (r1 == r2) ? r1 : r2;
    num = ((arg1 * m + arg2 * m) / m);
  } catch (error) {
    num = arg1
  }
  if (num == 'NaN') {
    num = arg1
  }
  try {
    num = num.toFixed(_this.accuracy)
  } catch (error) {

  }
  return num;
}
// 浮数减
export function subFloat(arg1, arg2) {
  if (!arg1) {
    arg1 = 0
  }
  if (!arg2) {
    arg2 = 0
  }
  let num = 0
  try {
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(100, Math.max(r1, r2));
    // 动态控制精度长度
    n = (r1 == r2) ? r1 : r2;
    num = ((arg1 * m - arg2 * m) / m);
  } catch (error) {
    num = arg1
  }
  if (num == 'NaN') {
    num = arg1
  }
  try {
    num = num.toFixed(_this.accuracy)
  } catch (error) {

  }
  return num;
}

